<template>
<div class="">
    <div class="content">
        <b-row>
            <el-col :span="24">
                <form @submit.prevent="submit">
                     <el-row type="flex" justify="end">
                        <!-- Node ID -->
                        <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.nodeID") }} </label></b-col>
                        <b-col cols="10"><b-form-input type="text" v-model.trim="pool.id" disabled></b-form-input></b-col>
                    </el-row>
                
                     <el-row type="flex" justify="end">
                        <!-- Operation -->
                        <b-col cols="2" class="right"><label class="w100 right"> Operation</label></b-col>
                        <b-col cols="10">
                            <b-form-select class="form-control" v-model="operation" :options="operations" @change="lastResult = null"/>
                        </b-col>
                    </el-row>

                     <el-row type="flex" justify="end">
                        <!-- Operation -->
                        <b-col cols="2" class="right"><label class="w100 right"> Command</label></b-col>
                        <b-col cols="10">
                            <b-form-input type="text" v-model.trim="$v.form.command.$model" :placeholder="getHelp()"></b-form-input>
                            <div v-if="$v.form.$error">
                                <div class="error" v-if="!$v.form.command.required">{{ $t('messages.login.error.required') }}</div>
                            </div>
                        </b-col>
                     </el-row>
                  
                    <el-row type="flex" justify="end">
                        <!-- Result -->
                        <b-col cols="2" class="right"><label class="w100 right"> Result</label></b-col>
                        <b-col cols="10">
                            <b-form-textarea v-model="lastResult" rows="3" max-rows="6" :disabled="lastResult == null"></b-form-textarea>
                        </b-col>
                    </el-row>
                    <!-- Save changes -->
                    <el-row type="flex" justify="end" v-if="!isLoading">
                        <button type="submit" class="button mtop10" :disabled="isLoading">Execute </button>
                    </el-row>

                    <div v-if="isLoading">
                        <md-progress-bar class="md-accent" md-mode="indeterminate"></md-progress-bar>
                    </div>
                
                    <el-row type="flex" class="mtop10">
                        <b-alert class="w100" show variant="info"><icon name="info-circle"> </icon><br/>
                            Decimal values<br/>
                            Read: REG_START,REG_COUNT<br/>
                            Write: REG_START:data1,REG_START:[dataN]<br/>
                            REG_START: 0 - 4095<br/>
                            REG_COUNT: 1 - 512 (and REG_START + REG_COUNT <= 4095)<br/>
                            data: 0 - 65535 
                        </b-alert>
                    </el-row>
                </form>
            </el-col>            
        </b-row>
    </div>
</div>

</template>

<script>
import { mapState} from 'vuex'
import {required} from 'vuelidate/lib/validators';
const fb = require('../firebaseConfig.js')

export default {
    name: 'poolcomm',
    props:{
        pool:Object
    },
    data: function () {
        return {
            operation: 'RRB',
            command: null,
            lastResult: null,
            isLoading: false,
            timeout: null,
            form: {
                command:null
            },
            operations: [
                {value: 'RRB', text:'Read registers', help:'REG_START,REG_COUNT'},
                {value: 'WRP', text:'Write registers', help:'REG:data1,REG:[dataN]'},
            ],
        };
    },
    validations: {
        form: {
            command: {
                required,
            },
        }
    },
    computed: {
        ...mapState(['currentUser']),
    },
    methods: {

        getHelp: function(){
            let info = this.operations.find(x => x.value === this.operation); 
            return info.help
        },
        submit() {
            this.$v.form.$touch();
            if (this.$v.form.$error){
                return
            }
           this.sendCommand();
        },
        sendCommand(){
            this.lastResult = null;
            this.isLoading = true;
            fb.poolsCollection.doc(this.pool.id).get().then( res=>{
                let connect = res.data().present
                if(!connect){
                    this.poolNotConnected('Pool not present');
                }else{
                    this.poolSubscribe();
                }
            })
        },
        poolSubscribe(){
            let newOperation = {
                'ts': Math.floor(Date.now() / 1000),
                'op': this.operation,
                'cmd': this.form.command,
                'user': this.currentUser.uid
            }
          
            fb.poolsCollection.doc(this.pool.id).collection('logs').add(newOperation).then((docRef) => { 
                this.prepareMessage(docRef.id)
                this.timeout = setTimeout(()=>{ 
                    console.log('Response timeout');
                    fb.poolsCollection.doc(this.pool.id).collection('logs').doc(docRef.id).update({'result': 'Response timeout'})
                    }, 10000); 
                let unsub = fb.poolsCollection.doc(this.pool.id).collection('logs').doc(docRef.id).onSnapshot(res => {
                    let data = res.data();
                    if(data && data.result){
                        let removeOp = data.result.split(' ')
                        if(this.operation == 'RRB' && data.result !='Response timeout'){
                            let arr = removeOp[1].split(',')
                            var initialreg;
                            let totals= arr.map( (val, index)=>{
                                var value;
                                if(index== 0){
                                    var parts = val.split(':')
                                    initialreg = parseInt(parts[0],16)
                                    value = parseInt(parts[1],16)
                                }else{
                                    initialreg = initialreg+ 1
                                    value = parseInt(val,16)
                                }
                                return initialreg+" = "+value
                            })
                            this.lastResult = totals.join('\n')
                        }else{
                          //this.lastResult =  removeOp[1]
                           this.lastResult = data.result
                        }
                        clearTimeout(this.timeout);
                        unsub()
                        this.isLoading = false;
                    }
                })
            },error => {
                this.poolNotConnected(error);
                unsub()
            });
        },
        prepareMessage(operationId){
            this.isLoading = true
            this.$store.dispatch('sendPoolCommandAWS', {
                'wifi': this.pool.wifi, 
                'id': this.pool.id,
                'operation': this.operation, 
                'changes': this.form.command,
                'operationId': operationId
            }).then(response => {
                //resolve({body: this.$t("messages.configRecieved"),config:{timeout:3000,closeOnClick: true}}) 
            }, error => {
                console.log('error');
                this.poolNotConnected(error)
            })
          
        },
        poolNotConnected(msg){
            this.isLoading = false;
            this.$snotify.error( msg, {
                timeout: 3000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Poolcomm.vue